import { Glue42 } from "../../glue";
import { setupInterop } from "./agm";
import { SharedContextSubscriber } from "./contexts";
import { ChannelsImpl } from "./channels";

export function factory(contexts: Glue42.Contexts.API, agm: Glue42.AGM.API, getWindows: () => Glue42.Windows.API, logger: Glue42.Logger.API): Glue42.Channels.API & { ready: () => Promise<void>; } {
    const sharedContexts = new SharedContextSubscriber(contexts);
    const channels = new ChannelsImpl(sharedContexts, agm, getWindows, logger);

    const setupInteropPromise = setupInterop(agm, channels);

    return {
        subscribe: channels.subscribe.bind(channels),
        subscribeFor: channels.subscribeFor.bind(channels),
        publish: channels.publish.bind(channels),
        all: channels.all.bind(channels),
        list: channels.list.bind(channels),
        get: channels.get.bind(channels),
        join: channels.join.bind(channels),
        leave: channels.leave.bind(channels),
        // @ignore-ed, but kept for backwards compatibility.
        current: channels.current.bind(channels),
        my: channels.my.bind(channels),
        // @ignore-ed, but kept for backwards compatibility.
        changed: channels.changed.bind(channels),
        onChanged: channels.onChanged.bind(channels),
        add: channels.add.bind(channels),
        remove: channels.remove.bind(channels),
        getWindowsOnChannel: channels.getWindowsOnChannel.bind(channels),
        getWindowsWithChannels: channels.getWindowsWithChannels.bind(channels),
        getMy: channels.getMy.bind(channels),
        ready: async () => {
            await Promise.all([(contexts as any).ready(), setupInteropPromise]);
        }
    };
}
